import { Component } from '@verndale/core';
import MicroModal from 'micromodal';
import serialize from 'form-serialize';
import axios from 'axios';
import Pristine from 'pristinejs';

import {
  SERIALIZE_SETTINGS,
  PRISTINE_SETTINGS
} from '../utils/default-settings';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $el: this.el,
      $form: this.el._$('.modal-notify-me__form'),
      $quantityInput:this.el._$('.modal-notify-me__form input[name="QuantityOfInterest"]'),
      $firstNameInput:this.el._$('.modal-notify-me__form input[name="FirstName"]'),
      $lastNameInput:this.el._$('.modal-notify-me__form input[name="LastName"]'),
      $emailInput:this.el._$('.modal-notify-me__form input[name="EmailAddress"]'),
      $orgInput:this.el._$('.modal-notify-me__form input[name="OrganizationName"]'),
      $recaptcha: this.el._$('.g-recaptcha'),
      $errorMessage: this.el._$(
        '.modal-notify-me__form__error-message'
      ),
      $btnSubmit: this.el._$(
        '.modal-notify-me__form button[type="submit"]'
      ),
      $notifyMeButton : this.el._$('.buy-now-notify-me-wrapper .btn'),
      $notifyMeConfirmation : this.el._$('.modal-notifyme-confirmation .confirmation-modal__accept'),
      $confirmationClose : this.el._$('.close-popup')
    };
    this.modalId = null;
    this.pristineForm = null;
    this.endpoint = this.dom.$form.getAttribute('action') || null;
    this.isCaptchaValid = false;

    this.init();
    this.pristineInit();
  } //setupDefaults

  addListeners() {
    const { $form, $quantityInput, $firstNameInput, $lastNameInput, $emailInput, $orgInput, $notifyMeButton, $notifyMeConfirmation, $confirmationClose } = this.dom;
    $form?._on('submit', this.submitForm.bind(this));

    document.addEventListener('click', e => {
      const $notifyMeButton = e.target.closest('.buy-now-notify-me-wrapper .btn');

      if ($notifyMeButton) {
        this.showModal(e, $notifyMeButton);
      }
    });

    if ($notifyMeConfirmation) {
      $notifyMeConfirmation.addEventListener('click', e => this.confirmationForm(e));
    }

    // $quantityInput?._on('change', this.validateInputs.bind(this));
    // $firstNameInput?._on('change', this.validateInputs.bind(this));
    // $lastNameInput?._on('change', this.validateInputs.bind(this));
    // $emailInput?._on('change', this.validateInputs.bind(this));
    // $orgInput?._on('change', this.validateInputs.bind(this));

    $form?._on('input', this.enableDisableSubmitBtn.bind(this));
    $form?._on('change', this.enableDisableSubmitBtn.bind(this));
    $confirmationClose._on('click', this.closeConfirmationModal.bind(this));
  } //addListeners

  init() {
    const { $el, $recaptcha, $btnSubmit } = this.dom;

    const $genericModal = $el.closest('.generic-modal');
    if ($genericModal) {
      this.modalId = $genericModal.getAttribute('id') || null;
    }

    if ($recaptcha) {
      window.onCallback = this.captchaSuccessCallback.bind(this);
      window.onCallbackExpired = this.captchaExpiredCallback.bind(this);
      window.recaptchaErrorCallback = this.captchaErrorCallback.bind(this);
    } else {
      this.isCaptchaValid = true;
    }

    $btnSubmit.disabled = true;
  } //init

  pristineInit() {
    const { $form } = this.dom;

    if ($form) {
      this.pristineForm = new Pristine($form, PRISTINE_SETTINGS);
    }
  } //pristineInit

  showModal(e, $notifyMeButton) {
    e?.preventDefault();

    if (!$notifyMeButton) return;

    const apiUrl = $notifyMeButton?.getAttribute('data-notifyme-details-endpoint') || null;
    const id = $notifyMeButton?.getAttribute('data-generic-modal-open') || $notifyMeButton?.getAttribute('modal-id') || null;

    const product_number = $notifyMeButton?.getAttribute('data-atcc-number');

    const firstNameInput = document.querySelector('[name="FirstName"]');
    const lastNameInput = document.querySelector('[name="LastName"]');
    const emailInput = document.querySelector('[name="EmailAddress"]');
    const organizationName = document.querySelector('[name="OrganizationName"]');
    const proName = document.querySelector('.modal-notify-me__description .product-name');
    const atccNum = document.querySelector('.modal-notify-me__description .atcc-num');
    const productName_hidden = document.querySelector('#ProductName');
    const atccNumber_hidden = document.querySelector('#ATCCNumber');
    const customerNumber_hidden = document.querySelector('#CustomerNumber');

    axios({
      method: 'get',
      url: `${apiUrl}?productNumber=${product_number}`
    })
      .then(response => {
        const { success, body } = response?.data || {};
        const { ProductName, ATCCNumber, FirstName, LastName, EmailAddress, OrganizationName, CustomerNumber } = body || {};

        if (success) {
          proName.innerHTML = ProductName;
          atccNum.innerHTML = ATCCNumber;
          productName_hidden.value = ProductName;
          atccNumber_hidden.value = ATCCNumber;
          firstNameInput.value = FirstName;
          lastNameInput.value = LastName;
          emailInput.value = EmailAddress;
          organizationName.value = OrganizationName;
          customerNumber_hidden.value = CustomerNumber;
        }
      })
      .catch(error => {
        console.log('Error fetching data:', error);
      });

    if (id) {
      MicroModal.show(id, {
        openTrigger: 'data-generic-modal-open',
        closeTrigger: 'data-generic-modal-close',
        openClass: 'generic-modal--open',
        disableScroll: true,
        disableFocus: true,
        awaitOpenAnimation: true,
        awaitCloseAnimation: true
      });
    }
  }

  submitForm(e) {
    e.preventDefault();
    const { $btnSubmit, $errorMessage } = this.dom;
    const valid = this.pristineForm.validate();
    if (valid) {
      $btnSubmit.disabled = true;
      if ($errorMessage){
        $errorMessage.style.display = 'none';
      }

      document.body.classList.add('notify-confirmation');

    } else {
      this.validateInputs();
    }
  } //submitForm

  confirmationForm(){
    const { $form, $btnSubmit, $errorMessage, $notifyMeConfirmation } = this.dom;
    const formData = serialize($form, SERIALIZE_SETTINGS);
    $notifyMeConfirmation.disabled = true;
    axios({
      method: 'post',
      url: this.endpoint,
      data: formData,
      headers: {
        'content-type': 'application/json'
      }
    })
      .then(response => {
        const { success, message } = response?.data;
        //document.body.classList.remove('notify-confirmation');
        $notifyMeConfirmation.disabled = false;

        if (success) {
          MicroModal.close(this.modalId);
          location.reload();
        } else {
          $errorMessage.innerHTML = message;
          $errorMessage.style.display = 'block';
        }
      })
      .finally(() => {
        $btnSubmit.disabled = false;
      });
  }

  closeConfirmationModal(){
    MicroModal.close(this.modalId);
    location.reload();
  }

  validateInputs() {
    try {
      const errors = this.pristineForm.getErrors();
      for (const error of errors) {
        const input = error.input;
        this.pristineForm.validate(input);
      }
    } catch (error) {
      return;
    }
  } //validateInputs

  enableDisableSubmitBtn() {
    const { $btnSubmit } = this.dom;

    try {
      const valid = this.pristineForm.validate(true);
      $btnSubmit.disabled = !valid;
      if (this.isCaptchaValid) {
        if (this.dom.$btnSubmit) this.dom.$btnSubmit.disabled = !valid;
      } else {
        if (this.dom.$btnSubmit) this.dom.$btnSubmit.disabled = true;
      }
    } catch (error) {
      return;
    }

  } //enableDisableSubmitBtn

  captchaSuccessCallback() {
    this.isCaptchaValid = true;
    this.enableDisableSubmitBtn();
  } //captchaSuccessCallback

  captchaExpiredCallback() {
    this.isCaptchaValid = false;
    this.enableDisableSubmitBtn();
  } //captchaExpiredCallback

  captchaErrorCallback() {
    this.isCaptchaValid = false;
    this.enableDisableSubmitBtn();
  } //captchaErrorCallback

}

export default Module;
